import styled, { css } from 'styled-components';
import { List, RowBuffer, RowChild } from 'styles';

const lastChildStyles = props =>
  !props.showPagination &&
  css`
    border-radius: 0 0 ${props => props.theme.borderRadii.large}
      ${props => props.theme.borderRadii.large};
    ${RowChild} {
      margin-bottom: 0;
      border-bottom: none;
    }
    &:hover {
      ${RowBuffer} {
        border-bottom: none;
      }
    }
  `;

export const StyledList = styled(List)`
  margin: 0;

  li:last-child {
    &:last-child {
      ${RowChild} {
        border-bottom: 1px solid
          ${props => props.theme.colors.background.tertiary};
      }
      ${lastChildStyles}
    }
  }
`;
